<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" top="5vh" width="1000px" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>选择适配设备分类</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-input placeholder="搜索" v-model="searchCategoryName" clearable>
        <el-button slot="prepend" icon="el-icon-search"></el-button>
      </el-input>
      <div class="category-list-wrapper" ref="categoryListWrapper">
        <el-tree
          class="filter-tree"
          show-checkbox
          highlight-current
          node-key="id"
          :data="options"
          :props="defaultProps"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
          @check-change="checkChange"
          ref="tree">
        </el-tree>
      </div>
      <el-checkbox v-model="adaptedCategoryType" :disabled="!!disabledCategories.length">通用</el-checkbox>
    </div>
    <div class="dialog-footer" style="padding-top: 10px; text-align: right;">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" @click="sure">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { treeByCodes, treeByCodes1xie } from '@/api/category';
export default {
  props: {
    useXieApi: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dialogVisible: false,
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      options: [],
      defaultCheckedKeys: [],
      disabledCategories: [],
      searchCategoryName: '',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      adaptedCategoryType: false,
    };
  },
  watch: {
    dialogVisible (v) {
      if (v && !this.options.length) {
        this.queryList();
      }
    },
    searchCategoryName (val) {
      this.$refs.tree.filter(val);
    },
    adaptedCategoryType (v) {
      if (v) {
        this.defaultCheckedKeys = [];
        this.$refs.tree?.setCheckedKeys([]);
      }
    },
    disabledCategories () {
      this.setDisabled(this.options);
    },
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleClose () {
      this.dialogVisible = false;
      this.searchCategoryName = '';
      this.defaultCheckedKeys = [];
      this.disabledCategories = [];
    },
    checkChange (data, checked) {
      if (checked) {
        this.adaptedCategoryType = false;
      }
    },
    //  递归list,找到disabledCategories中包含的项设置disabled为true
    setDisabled (items) {
      items.forEach(item => {
        if (this.disabledCategories.includes(item.id)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.children && item.children.length) {
          this.setDisabled(item.children);
        }
      });
    },
    sure () {
      this.$emit('saveDeviceCategory', {selectedLists: this.$refs.tree.getCheckedNodes(), adaptedCategoryType: this.adaptedCategoryType});
      this.handleClose();
    },
    async queryList () {
      const apiFunc = this.useXieApi ? treeByCodes1xie : treeByCodes;
      apiFunc({
        codes: ['MEDICAL_DEVICE', 'NON_MEDICAL_DEVICE'],
        enableFlag: true,
        includeSelfFlag: true,
      }).then(res => {
        let list = res.body || [];
        this.setDisabled(list);
        this.options = list;
      });
    },
  },
  mounted () {
    this.queryList();
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content {
    padding: 0 10px;

    .category-list-wrapper {
      max-height: 55vh;
      overflow-y: auto;
      padding: 10px 0;
      margin: 10px 0;
    }
  }
}
</style>
